"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
var Token = /** @class */ (function () {
    function Token() {
    }
    Token.fromJson = function (json) {
        var instance = new Token();
        instance.tokenType = json.token_type;
        instance.expiresIn = json.expires_in;
        instance.extExpiresIn = json.ext_expires_in;
        instance.expiresOn = json.expires_on;
        instance.notBefore = json.not_before;
        instance.resource = json.resource;
        instance.accessToken = json.access_token;
        return instance;
    };
    return Token;
}());
exports.Token = Token;
